import Vue from 'vue';
import BaseSocials from '../../mixins/BaseSocial/BaseSocial.js';
import getSerialisedParams from '../../utils/getSerialisedParams.js';

/**
 * Hey!
 *
 * SLiveJournal component used for LiveJournal social network
 * @link https://www.livejournal.com/
 */
/**
 * Share parameters for link
 * @link https://www.livejournal.com/developer/extshare
 */

var SLiveJournal = /* #__PURE__ */Vue.extend({
  name: 'SLiveJournal',
  mixins: [BaseSocials('LiveJournal')],
  computed: {
    networkURL: function networkURL() {
      var BASE_URL = 'http://www.livejournal.com/update.bml';
      var shareOptions = this.shareOptions;
      var subject = shareOptions.subject,
          url = shareOptions.url;
      var serialisedParams = getSerialisedParams({
        event: url,
        subject: subject
      });
      return "".concat(BASE_URL).concat(serialisedParams);
    }
  },
  render: function render(h) {
    return this.generateComponent(h, this.networkURL);
  }
});

export default SLiveJournal;
